module.exports = __webpack_public_path__ + "static/media/acredite-e-ganhe-telhanorte.56886b7c.jpg";